import Cookie from 'js-cookie';

const storageKey = 'nifty_';

export const set = (key, value, options) => {
    Cookie.set(storageKey + key, JSON.stringify(value), options);
}

export const get = (key, options) => {
    const result = Cookie.get(storageKey + key, options);

    try {
        return JSON.parse(result);
    } catch(e) {
        return result;
    }
}

export const remove = (key, options) => {
    Cookie.remove(storageKey + key, options);
}
